import config from "@/config";

export function getLocale(): string {
  return config.locale;
}

interface Locale {
  [k: string]: string | Locale;
}

export function loadLocaleMessages() {
  const locales = require.context("@/locales/messages", false, /[A-Za-z0-9-_,\s]+\.ts$/i);
  const locations = require.context("@/locales/locations", false, /[A-Za-z0-9-_,\s]+\.ts$/i);
  const messages: { [k: string]: Locale } = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale: string = matched[1];
      messages[locale] = locales(key).default;
      const locationKey = key.replace(".json", ".ts");
      if (locations.keys().indexOf(locationKey) > -1) {
        messages[locale] = {
          ...messages[locale],
          $locations: locations(locationKey).default,
        };
      }
    }
  });

  return messages;
}
